import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "icon" ]

  initialize() {
    this.themeMode = localStorage.getItem("themeMode") || "light"
  }

  connect() {
    this.setTheme()
  }

  setLight() {
    this.themeMode = "light"
    this.setTheme()
  }

  setDark() {
    this.themeMode = "dark"
    this.setTheme()
  }

  setTheme() {
    document.documentElement.setAttribute("data-bs-theme", this.themeMode)
    localStorage.setItem("themeMode", this.themeMode)

    if (this.themeMode == "dark") {
      document.querySelector(".theme-dark").classList.remove("d-none")
      document.querySelector(".theme-light").classList.add("d-none")
    } else {
      document.querySelector(".theme-dark").classList.add("d-none")
      document.querySelector(".theme-light").classList.remove("d-none")
    }
  }
}
